import { Component, OnInit } from "@angular/core";

enum Country {
  NIGERIA,
  GHANA,
}

@Component({
  selector: "app-design-page",
  templateUrl: "./design-page.component.html",
  styleUrls: ["./design-page.component.css"],
})
export class DesignPageComponent implements OnInit {
  currentCountry: Country = Country.NIGERIA;
  closeIcon: boolean = false;

  constructor() {}

  ngOnInit() {}

  switchToNg() {
    this.currentCountry = Country.NIGERIA;
  }

  switchToGh() {
    this.currentCountry = Country.GHANA;
  }

  toggleBurgerNav() {
    let menuItems = Array.from(
      document.getElementsByClassName("menu") as HTMLCollectionOf<HTMLLIElement>
    );

    if (menuItems[0].className.includes("not-responsive")) {
      menuItems.forEach(
        (menu) =>
          (menu.className = menu.className.replace(
            "not-responsive",
            "responsive"
          ))
      );
      this.closeIcon = true;
    } else {
      menuItems.forEach(
        (menu) =>
          (menu.className = menu.className.replace(
            "responsive",
            "not-responsive"
          ))
      );
      this.closeIcon = false;
    }
  }
}
